import type { McpConfigScope } from '@gitlab-org/ai-configuration';
import type { McpConfigScopeLabel } from '@gitlab-org/tui';

export const SCOPE_LABELS: Record<McpConfigScope, McpConfigScopeLabel> = {
  workspace: 'project',
  user: 'user',
  plugin: 'plugin',
};
